import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { IPredictionGroupingDto } from 'api/api';
import { InputText } from 'primereact/inputtext';
import React, { useEffect, useMemo, useState } from 'react';
import { reactAI } from 'services/telemetry-service';
import { getPredictions } from 'state/ducks/prediction-table-settings/actions';
import { localized } from 'state/i18n';
import PredictionTable from 'view/components/table/bi-table/prediction-table';
import WhiteCard from 'view/shared/components/cards/white-card';
import { ProfileCardDoubleContainerLength } from '../administration';
import '../adminstration.scss';
import { PredictionSummary } from '../cards/predictions/prediction-summary';

const MachineLearningAdministrationPage: React.FC = () => {
	const [searchTerm, setSearchTerm] = useState('');
	const [deferredSearchTerm, setDeferredSearchTerm] = useState('');
	const [groupings, setGroupings] = useState<IPredictionGroupingDto[]>([]);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		let isMounted = true;
		const fetchData = async () => {
			setIsLoading(true);
			const data = await getPredictions();
			if (isMounted) {
				setGroupings(data ?? []);
				setIsLoading(false);
			}
		};
		fetchData();

		return () => {
			isMounted = false;
		};
	}, []);

	useEffect(() => {
		const timer = setTimeout(() => {
			setDeferredSearchTerm(searchTerm);
		}, 300);

		return () => clearTimeout(timer);
	}, [searchTerm]);

	const groupingsToDisplay = useMemo(() => {
		if (!deferredSearchTerm) return groupings;

		const lowerSearch = deferredSearchTerm.toLowerCase();
		return groupings.filter(g => g.serialNumber?.toLowerCase().includes(lowerSearch));
	}, [groupings, deferredSearchTerm]);

	return (
		<div className="flex-direction-row flex-wrap flex-start-column">
			<div className="flex-direction-row">
				<WhiteCard
					title={localized('Predictions')}
					classNameContainer={`${ProfileCardDoubleContainerLength.classNameContainer}`}
				>
					<PredictionSummary loading={isLoading} data={groupingsToDisplay} />
				</WhiteCard>
			</div>
			<div className="flex-direction-row">
				<WhiteCard
					title={localized('Predictions')}
					classNameContainer={`${ProfileCardDoubleContainerLength.classNameContainer}`}
				>
					<span>
						<InputText
							placeholder={localized('Search')}
							value={searchTerm}
							onChange={e => setSearchTerm(e.currentTarget.value)}
						/>
					</span>
					<PredictionTable data={groupingsToDisplay} loading={isLoading} />
				</WhiteCard>
			</div>
		</div>
	);
};

export default withAITracking(
	reactAI.reactPlugin,
	MachineLearningAdministrationPage,
	'MachineLearningAdministrationPage'
);
